const rootElement = document.querySelector('[data-selector="hb-lp-compare-new"]')
const modal = rootElement.querySelector('[data-compare-modal]');
const openBtn = rootElement.querySelector('[data-open-modal]');
const closeBtn = modal.querySelector('[data-modal-close]');
const overlay = modal.querySelector('[data-modal-overlay]');
const modalContent = modal.querySelector('[data-modal-content]');
const tabsContainer = modal.querySelector('[data-compare-tabs-container]');

const seasonalIncomeValueElements = Array.from(
  rootElement.querySelectorAll('[data-selector="seasonal-income-value"]')
);

const DEVICES = {
  'maxi-pro': { th: 60, wh: 1500 },
  maxi: { th: 39, wh: 1500 },
  trio: { th: 10, wh: 1500 },
  canvas: { th: 10, wh: 400 }
};


fetch('https://api.heatbit.com/api/v2.0/currency/rates')
  .then((res) => res.json())
  .then((data) => {
    const { btcPrice, hashValue } = data.body;

    seasonalIncomeValueElements.forEach(el => {
      const deviceLabel = el.dataset.device;
      const selectedDevice = DEVICES[deviceLabel];

      if (!selectedDevice) return;

      const day = 30.5;
      const monthNumber = 6;
      const deviceNumber = 1;

      const incomeUsd = Math.round(
        btcPrice * hashValue * selectedDevice.th * day * monthNumber * deviceNumber
      );

      el.innerText = `≈ $${incomeUsd} / season *`;
    });
  })
  .catch(() => {
    console.error('An error has occured while enabling profit calculator');
  });

const openModal = () => {
  modal.classList.remove('tw:pointer-events-none');
  modal.classList.add('tw:opacity-100');

  if (overlay) overlay.classList.add('tw:opacity-100');

  if (modalContent) {
    modalContent.classList.add('tw:opacity-100', 'tw:scale-100');
    modalContent.classList.remove('tw:scale-95');
  }

  document.body.style.overflow = 'hidden';
};

const closeModal = () => {
  modal.classList.remove('tw:opacity-100');

  if (overlay) overlay.classList.remove('tw:opacity-100');

  if (modalContent) {
    modalContent.classList.remove('tw:opacity-100', 'tw:scale-100');
    modalContent.classList.add('tw:scale-95');
  }

  document.body.style.overflow = '';

  setTimeout(() => {
    modal.classList.add('tw:pointer-events-none');
  }, 300);
};

if (openBtn) openBtn.addEventListener('click', openModal);
if (closeBtn) closeBtn.addEventListener('click', closeModal);
if (overlay) overlay.addEventListener('click', closeModal);

modal.querySelectorAll('[data-tab-trigger]').forEach(button => {
  button.addEventListener('click', () => {
    const tabId = button.getAttribute('data-tab-trigger');

    modal.querySelectorAll('[data-compare-tab]').forEach(tab => {
      const isActive = tab.getAttribute('data-compare-tab') === tabId;

      if (isActive) {
        tab.classList.remove('tw:hidden');
      } else {
        tab.classList.add('tw:hidden');
      }
    });

    modal.querySelectorAll('[data-tab-trigger]').forEach(btn => {
      btn.classList.remove('tw:bg-black', 'tw:text-white');
      btn.classList.add('tw:text-[#7A7A7A]');
    });

    button.classList.add('tw:bg-black', 'tw:text-white');
    button.classList.remove('tw:text-[#7A7A7A]');
  });
});

rootElement.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeModal();
});
